import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
import { UrlImportJobSettings } from "app/Model/recurringJobs/urlImportJobSettings";
import { Observable, of } from "rxjs";
import { last } from "rxjs/operators";
import { LoginService } from "./login.service";
import { GenericService } from "./generic/genericRepository.service";


@Injectable()
export class UrlImportJobSettingsService extends GenericService<UrlImportJobSettings> {
  constructor(http: HttpClient) {
    super(http);
    this.apiUrl ="api/UrlImportSettings";
  }

  public run(id: number, customerId: string): Observable<UrlImportJobSettings> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString()).append("customerId", customerId.toString())
    }
    return (this.http.get<object>(`${this.apiUrl}/run`, options)) as any;
  }
}